import { render, staticRenderFns } from "./dui-gallery-thumbnail.vue?vue&type=template&id=1f93dd44&"
import script from "./dui-gallery-thumbnail.vue?vue&type=script&lang=js&"
export * from "./dui-gallery-thumbnail.vue?vue&type=script&lang=js&"
import style0 from "./dui-gallery-thumbnail.vue?vue&type=style&index=0&id=1f93dd44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports